import axios from "axios";
import { authGet, authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/w188_api";

export function callTransactionReport(queryParams) {
  return authPost(`${baseUrl}/Member4.ashx`, queryParams);
}
